import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_PIPELINES } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import Loader from "@/components/Loader";

const Deals = lazy(() => import("@pages/deals"));
const DealDetails = lazy(() => import("@pages/deals/deal-details/deal.details.container"));

const dealsRoutes = [
  {
    path: PATH_PIPELINES,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: <Deals />,
        index: true,
      },
      {
        path: "deals/:dealId",
        element: <DealDetails />,
      },
    ],
  },
];

export default dealsRoutes;
